import { useSelector } from 'react-redux';
import { isSmallScreen } from '../selectors/window';

const useIsSmallScreen = () => {
	return useSelector(isSmallScreen);
}

export default useIsSmallScreen;